import { defineMessage } from 'services/localization';

export const messages = {
    paymentProcessingDetails: defineMessage('payment_processing_details'),
    totalPayments: defineMessage('total_payments'),
    paymentsSent: defineMessage('payments_sent'),
    paymentsFailed: defineMessage('payments_failed'),
    paymentsInProcessing: defineMessage('payments_in_processing'),
};
